const STORAGE_KEY = "rzDetailReturn";
const RATINGS_RETURN_KEY = "rzRatingsReturn";

export function isBrowseDetailHash(hash) {
  const h = hash || "";
  return /^#\/browse\/(movie|tv)\/[^/?#]+$/i.test(h);
}

export function hashToReturnTarget(hash) {
  const raw = (hash || "").trim();
  const h = raw === "" ? "#" : raw.startsWith("#") ? raw : `#${raw}`;

  if (h === "#" || h === "#/") {
    return { hash: "", label: "Home" };
  }
  if (h === "#/browse" || h === "#/browse/") {
    return { hash: "#/browse", label: "Browse" };
  }
  if (h.startsWith("#/ratings")) {
    return { hash: "#/ratings", label: "Your ratings" };
  }
  if (h.startsWith("#/watchlist")) {
    return { hash: "#/watchlist", label: "Watchlist" };
  }
  if (h.startsWith("#/suggestions")) {
    return { hash: "#/suggestions", label: "Suggestions" };
  }
  if (h.startsWith("#/favorites")) {
    return { hash: "#/favorites", label: "Favorites" };
  }
  if (h.startsWith("#/lists")) {
    return { hash: h.split("?")[0], label: "Lists" };
  }
  if (h.startsWith("#/top100")) {
    return { hash: h.split("?")[0], label: "Top 100" };
  }
  if (h.startsWith("#/profile")) {
    return { hash: "#/profile", label: "Profile" };
  }
  if (h.startsWith("#/settings")) {
    return { hash: "#/settings", label: "Settings" };
  }
  if (h.startsWith("#/notifications")) {
    return { hash: "#/notifications", label: "Notifications" };
  }
  if (h.startsWith("#/user/")) {
    return { hash: h.split("?")[0], label: "Profile" };
  }
  if (h.startsWith("#/community")) {
    return { hash: "#/community", label: "Community" };
  }
  if (h.startsWith("#/admin")) {
    return { hash: "#/admin", label: "Admin" };
  }
  if (h.startsWith("#/browse/movie/") || h.startsWith("#/browse/tv/")) {
    return { hash: "#/browse", label: "Browse" };
  }
  return { hash: "#/browse", label: "Browse" };
}

export function saveBrowseDetailReturn(prevHash) {
  if (isBrowseDetailHash(prevHash)) return;
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(hashToReturnTarget(prevHash)));
  } catch {
    void 0;
  }
}

export function readBrowseDetailReturn() {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return { hash: "#/browse", label: "Browse" };
    const parsed = JSON.parse(raw);
    if (parsed && typeof parsed.hash === "string" && typeof parsed.label === "string") {
      return parsed;
    }
  } catch {
    void 0;
  }
  return { hash: "#/browse", label: "Browse" };
}

export function hashPathForLocation(targetHash) {
  const h = targetHash ?? "";
  if (h === "" || h === "#" || h === "#/") return "";
  return h.startsWith("#") ? h.slice(1) : h;
}

export function detailBackButtonLabel() {
  const { label } = readBrowseDetailReturn();
  return `← Back to ${label}`;
}

export function saveRatingsPageReturn(prevHash) {
  const p = prevHash || "";
  if (p === "#/ratings") return;
  try {
    sessionStorage.setItem(RATINGS_RETURN_KEY, JSON.stringify(hashToReturnTarget(p)));
  } catch {
    void 0;
  }
}

export function readRatingsPageReturn() {
  try {
    const raw = sessionStorage.getItem(RATINGS_RETURN_KEY);
    if (!raw) return { hash: "#/profile", label: "Profile" };
    const parsed = JSON.parse(raw);
    if (parsed && typeof parsed.hash === "string" && typeof parsed.label === "string") {
      return parsed;
    }
  } catch {
    void 0;
  }
  return { hash: "#/profile", label: "Profile" };
}

export function hrefFromReturnHash(targetHash) {
  const p = hashPathForLocation(targetHash);
  if (p === "") return "#/";
  return `#${p}`;
}
